<div id="foto" class="container user-info mb-48 ml-24 thumbnail-wrapper" fxLayoutAlign.sm="center center">
    <img id="img-edit" class="profile-image avatar huge" [src]="src" />
    <button type="button" id="foto-btn-editar" (click)="this.alterar()" mat-mini-fab class="btn-img">
        <mat-icon>edit</mat-icon>
    </button>
</div>
